module.exports = __webpack_public_path__ + "img/carousel-image4.c5161156.jpg";